export default "__VITE_ASSET__BQz4ZTzm__"